import { createReducer } from '@reduxjs/toolkit';

import { InitialState } from './types';
import {
  setAuthDrawerActive,
  setCity,
  setCityPopupActive,
  setFavouriteProducts,
  setMenuActive,
  setMenuSearchActive,
  setSearchActive,
  setSelectCityDrawerActive,
  setCartData,
  setCartDrawerActive,
  setAvailableLocations,
  setCategoryTree,
  setTempCartItems,
  setOrderUserCorrect,
  setOrderDeliveryCorrect,
  setOrderCompanyInvoiceCorrect,
  setCatalogActive,
  setPartnersDrawerActive,
  setDeletedCartItems,
  addDeletedCartItem,
  removeDeletedCartItem,
  setAlert,
  setHeaderButtonColor,
  setHelpDrawerActive,
  setHelpDrawerScreen,
} from './actions';

const initialState: InitialState = {
  menuActive: false,
  city: null,
  cityPopupActive: false,
  selectCityDrawerActive: false,
  menuSearchActive: false,
  searchActive: false,
  authDrawerActive: false,
  favouriteProducts: [],
  cartData: null,
  cartDrawerActive: false,
  availableLocations: [],
  categoryTree: [],
  tempCartItems: [],
  orderUserCorrect: false,
  orderDeliveryCorrect: false,
  orderCompanyInvoiceCorrect: true,
  catalogActive: false,
  partnersDrawerActive: false,
  deletedCartItems: [],
  alert: '',
  headerButtonColor: '#000',
  helpDrawerActive: false,
  helpDrawerScreen: 'Телефон',
};

export const appReducer = createReducer(initialState, (builder) => {
  builder.addCase(setMenuActive, (state, action) => {
    state.menuActive = action.payload;
  });
  builder.addCase(setCityPopupActive, (state, action) => {
    state.cityPopupActive = action.payload;
  });
  builder.addCase(setSelectCityDrawerActive, (state, action) => {
    state.selectCityDrawerActive = action.payload;
  });
  builder.addCase(setCity, (state, action) => {
    state.city = action.payload;
  });
  builder.addCase(setMenuSearchActive, (state, action) => {
    state.menuSearchActive = action.payload;
  });
  builder.addCase(setSearchActive, (state, action) => {
    state.searchActive = action.payload;
  });
  builder.addCase(setAuthDrawerActive, (state, action) => {
    state.authDrawerActive = action.payload;
  });
  builder.addCase(setFavouriteProducts, (state, action) => {
    state.favouriteProducts = action.payload;
  });
  builder.addCase(setCartData, (state, action) => {
    state.cartData = action.payload;
  });
  builder.addCase(setCartDrawerActive, (state, action) => {
    state.cartDrawerActive = action.payload;
  });
  builder.addCase(setAvailableLocations, (state, action) => {
    state.availableLocations = action.payload;
  });
  builder.addCase(setCategoryTree, (state, action) => {
    state.categoryTree = action.payload;
  });
  builder.addCase(setTempCartItems, (state, action) => {
    state.tempCartItems = action.payload;
  });
  builder.addCase(setOrderUserCorrect, (state, action) => {
    state.orderUserCorrect = action.payload;
  });
  builder.addCase(setOrderDeliveryCorrect, (state, action) => {
    state.orderDeliveryCorrect = action.payload;
  });
  builder.addCase(setOrderCompanyInvoiceCorrect, (state, action) => {
    state.orderCompanyInvoiceCorrect = action.payload;
  });
  builder.addCase(setCatalogActive, (state, action) => {
    state.catalogActive = action.payload;
  });
  builder.addCase(setPartnersDrawerActive, (state, action) => {
    state.partnersDrawerActive = action.payload;
  });
  builder.addCase(setDeletedCartItems, (state, action) => {
    state.deletedCartItems = action.payload;
  });
  builder.addCase(addDeletedCartItem, (state, action) => {
    state.deletedCartItems = [
      ...state.deletedCartItems.filter((item) => item.id !== action.payload.id),
      action.payload,
    ];
  });
  builder.addCase(removeDeletedCartItem, (state, action) => {
    state.deletedCartItems = state.deletedCartItems.filter(
      (item) => item.id !== action.payload,
    );
  });
  builder.addCase(setAlert, (state, action) => {
    state.alert = action.payload;
  });
  builder.addCase(setHeaderButtonColor, (state, action) => {
    state.headerButtonColor = action.payload;
  });
  builder.addCase(setHelpDrawerActive, (state, action) => {
    state.helpDrawerActive = action.payload;
  });
  builder.addCase(setHelpDrawerScreen, (state, action) => {
    state.helpDrawerScreen = action.payload;
  });
});
